import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

const normalizeCostCentreList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && typeof payload === 'object') {
    if (Array.isArray(payload.data)) {
      return payload.data;
    }

    if (Array.isArray(payload.results)) {
      return payload.results;
    }
  }

  return [];
};

// GET all costCentres
export const getCostCentre = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/cost-centres`, {
      params,
      paramsSerializer: (searchParams) => {
        const query = new URLSearchParams();
        for (const key in searchParams) {
          const value = searchParams[key];
          if (Array.isArray(value)) {
            value.forEach((v) => query.append(key, v));
          } else if (value !== undefined && value !== null && value !== '') {
            query.append(key, value);
          }
        }
        return query.toString();
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching costCentres:", error.response?.data || error);
    throw error;
  }
};

// GET paginated cost centres for dropdowns
export const getPaginatedCostCentres = async ({
  page = 1,
  pageSize = 10,
  search = '',
} = {}) => {
  try {
    const payload = await getCostCentre({ page, pageSize, search });
    const data = normalizeCostCentreList(payload);
    const total =
      (payload && typeof payload === 'object' && typeof payload.total === 'number')
        ? payload.total
        : data.length;
    const normalizedPageSize =
      (payload && typeof payload === 'object' && typeof payload.pageSize === 'number')
        ? payload.pageSize
        : pageSize;
    const normalizedPage =
      (payload && typeof payload === 'object' && typeof payload.page === 'number')
        ? payload.page
        : page;

    return {
      data,
      total,
      page: normalizedPage,
      pageSize: normalizedPageSize,
      hasMore:
        (payload && typeof payload === 'object' && typeof payload.hasMore === 'boolean')
          ? payload.hasMore
          : normalizedPage * normalizedPageSize < total,
    };
  } catch (error) {
    console.error('Error fetching costCentres:', error.response?.data || error);
    throw error;
  }
};

export const clearCostCentreCache = () => {
  // no-op retained for compatibility
};

// GET a single costCentre
export const getCostCentreById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/cost-centres/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching costCentre:", error.response?.data || error);
    throw error;
  }
};

// CHECK for duplicate cost centre by code or name
export const checkCostCentreDuplicate = async (
  costCentreCode,
  costCenterDescription,
  excludeId,
) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/cost-centres/check-duplicate`,
      {        params: { code: costCentreCode, name: costCenterDescription, excludeId },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error checking costCentre:',
      error.response?.data || error,
    );
    throw error;
  }
};

// CREATE a new costCentre
export const createCostCentre = async (costCentreData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/cost-centres`, costCentreData);
    return response.data;
  } catch (error) {
    console.error("Error creating costCentre:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing costCentre
export const updateCostCentre = async (id, costCentreData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/cost-centres/${id}`, costCentreData);
    return response.data;
  } catch (error) {
    console.error("Error updating costCentre:", error.response?.data || error);
    throw error;
  }
};

// DELETE a costCentre
export const deleteCostCentre = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/cost-centres/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting costCentre:", error.response?.data || error);
    throw error;
  }
};
